import * as React from "react";
import { connect } from "react-redux";
import * as actions from "redux/actions/commentActions";
import { Translate } from "react-redux-i18n";
import { EllipsisH } from "theme/icon";

const CommentBtnRight = (props) => {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        const onDocumentClick = (event) => {
            if (event.target?.id !== 'button_menu_wall' && event.target?.id !== 'menu_swall') {
                setOpen(false);
            }
        };
        document.addEventListener('click', onDocumentClick);
        return () => document.removeEventListener('click', onDocumentClick);
    }, []);

    const handleClick = (event) => {
        event.stopPropagation();
        setOpen((prev) => !prev);
    };

    const onClickDelete = () => {
        props.removeItem(
            {
                comment_id: props.item.id,
                id: props.user_id,
            },
            props.token,
        );
        setOpen(false);
    };

    const onClickReport = () => {
        props.reportItem(
            {
                comment_id: props.item.id,
                id: props.user_id,
            },
            props.token,
        );
        setOpen(false);
    };
    return (
        <div>
            <span 
                className="icon-button"
                id={'button_menu_wall'}
                style={{
                    padding: '3px',
                    background: 'gray',
                    borderRadius: '50%'
                }}
                // aria-controls={open ? 'basic-menu' : undefined}
                // aria-haspopup="true"
                // aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <EllipsisH id="button_menu_wall" />
            </span>
            {open && (
            <ul
            className="list"
            id="menu_wall"
                style={{
                    background: '#1b3745',
                    position: 'absolute',
                    zIndex: 1,
                    margin: 0,
                    padding: 0,
                    listStyle: 'none',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {

                    props.user_id === props.item?.user?.id
                        ?
                        (
                            <li className="list-item" key={1} onClick={onClickDelete} style={{ "width": "100%" , paddingInline: "8px"}}>
                                <Translate value="delete" />
                            </li>
                        )
                        :
                        (
                            <li className="list-item" key={1} onClick={onClickReport} style={{ "width": "100%" , paddingInline: "8px"}}>
                                <Translate value="banned" />
                            </li>
                        )
                }
            </ul>
            )}
        </div>
    );

}

function mapStateToProps(reducer) {
    // console.log(reducer);   {values.menu}
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        user: reducer.session.auth,
        // lang: reducer.i18n.locale,
    };
}

const mapDispatchToProps = dispatch => ({
    removeItem: (params, token) =>
        dispatch(actions.removeItem({ params, token })),
    reportItem: (params, token) =>
        dispatch(actions.reportItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentBtnRight);
